// extracted by mini-css-extract-plugin
module.exports = {"green-button":"EducationTable_green-button__3ZcND"};